const cursorLocation = ref({ x: 0, y: 0 });

export const initCursorTracking = () => {
    window.addEventListener('mousemove', (e) => {
        cursorLocation.value = { x: e.clientX, y: e.clientY };
    });
}

type cursorAlertOptions = {
    duration?: number;
    targetElement?: HTMLElement;
    position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right' | 'center' | 'bottom-center';
    quadrant?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
}
export const cursorAlert = (
    msg:string, 
    _options?:cursorAlertOptions
) => {
    const options = _options || {};
    const alert = document.createElement('div');
    alert.style.position = 'fixed';
    alert.style.zIndex = '9999';
    alert.style.backgroundColor = 'rgba(0,0,0,0.5)';
    // alert.style.backdropFilter = 'blur(15px)';
    alert.style.color = 'white';
    alert.style.padding = '10px';
    alert.style.borderRadius = '5px';
    alert.style.boxShadow = '0 0 10px rgba(0,0,0,0.5)';
    alert.style.transition = 'all 0.3s';
    alert.style.transform = 'scale(0)';
    alert.style.pointerEvents = 'none'
    alert.style.fontSize = '16px'
    alert.innerHTML = msg;

    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;


    if(options.targetElement){
        // relative to targetElement
        const rect = options.targetElement.getBoundingClientRect();
        const quadrant = options.quadrant || (rect.left > windowWidth / 2
            ? rect.top > windowHeight / 2 ? 'bottom-right' : 'top-right'
            : rect.top > windowHeight / 2 ? 'bottom-left' : 'top-left');
        const position = options.position || 'center';
        alert.style.transformOrigin = quadrant === 'top-left' ? 'top left' : quadrant === 'top-right' ? 'top right' : quadrant === 'bottom-left' ? 'bottom left' : 'bottom right';
        alert.style.top = position.indexOf('top') > -1 ? rect.top + 'px' : '';
        alert.style.bottom = position.indexOf('bottom') > -1 ? windowHeight - rect.bottom + 'px' : '';
        alert.style.left = position.indexOf('left') > -1 ? rect.left + 'px' : position.indexOf('center') > -1 ? (rect.left + rect.width / 2) + 'px' : '';
        alert.style.right = position.indexOf('right') > -1 ? windowWidth - rect.right + 'px' : '';

        if(position === 'center'){
            alert.style.top = (rect.top + rect.height / 2 / 1.618) + 'px';
            alert.style.left = (rect.left + rect.width / 2 / 1.618) + 'px';
        }
    }else{
        // relative to mouse
        if (cursorLocation.value.x === 0 && cursorLocation.value.y === 0) {
            initCursorTracking();
            return
        }
        const quadrant = cursorLocation.value.x > windowWidth / 2
            ? cursorLocation.value.y > windowHeight / 2 ? 'bottom-right' : 'top-right'
            : cursorLocation.value.y > windowHeight / 2 ? 'bottom-left' : 'top-left';
        
        alert.style.transformOrigin = quadrant === 'top-left' ? 'top left' : quadrant === 'top-right' ? 'top right' : quadrant === 'bottom-left' ? 'bottom left' : 'bottom right';
        alert.style.top = quadrant.indexOf('top') > -1 ? cursorLocation.value.y + 'px' : '';
        alert.style.bottom = quadrant.indexOf('bottom') > -1 ? windowHeight - cursorLocation.value.y + 'px' : '';
        alert.style.left = quadrant.indexOf('left') > -1 ? (cursorLocation.value.x + 30) + 'px' : '';
        alert.style.right = quadrant.indexOf('right') > -1 ? windowWidth - (cursorLocation.value.x + 30) + 'px' : '';
    }


    document.body.appendChild(alert);

    setTimeout(() => {
        alert.style.transform = 'scale(1)';
        setTimeout(() => {
            alert.style.opacity = '0';
            setTimeout(() => {
                document.body.removeChild(alert);
            }, 300);
        }
        , options.duration || 600);
    }, 100);

}